export class LicenseHistoryRecord {
    owner: string;
    approvalDate: string;
}
